<app-navbar></app-navbar>
<div class="container" style="text-align: center;">
  <h1 style="color: white;">Admission Procedure</h1>

  <div class="video-container" style='margin-top: 15px; margin-bottom: 15px;'>
    <img src="assets/img/school/Admission Procedure.jpg" alt="">
</div>